export default class Coze {
  static async stream (url, data, headers = {}, onData, onError, controller) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          ...headers,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        signal: controller.signal
      })

      if (!response.body) {
        throw new Error('No response body')
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')
      let buffer = ''

      while (true) {
        const { value, done } = await reader.read()
        if (done) break

        const chunk = decoder.decode(value, { stream: true })

        buffer += chunk

        let boundary = buffer.indexOf('\n\n')
        while (boundary !== -1) {
          const eventString = buffer.slice(0, boundary).trim()
          buffer = buffer.slice(boundary + 2)
          boundary = buffer.indexOf('\n\n')

          if (eventString.startsWith('data:')) {
            const jsonString = eventString.replace(/^data:/, '').trim()
            try {
              const json = JSON.parse(jsonString)
              onData(json)
            } catch (error) {
              console.error('Error parsing JSON:', error, 'Original text:', jsonString)
              onError(error)
            }
          }
        }
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Stream aborted')
      } else {
        console.error('Stream error:', error)
        onError(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/coze.js